import { jsx as a, jsxs as n, Fragment as x } from "react/jsx-runtime";
import { Icon as s } from "../icon/icon.js";
import { forwardRef as l } from "react";
import { FlexBlock as m } from "../../primitives/flex-block/flex-block.js";
import u from "clsx";
import { h as b, i as k } from "../../virginmediao2-momentum-icons-icons-far-BWte5zss.js";
import { m as f, g as C } from "../../virginmediao2-momentum-icons-icons-fas-C-qJ8QLF.js";
import '../../assets/card.css';const g = "_card_kuhxm_1", y = "_card__label_kuhxm_29", F = "_card__input_kuhxm_36", r = {
  card: g,
  "card--border-1": "_card--border-1_kuhxm_11",
  "card--border": "_card--border_kuhxm_11",
  "card--border-2": "_card--border-2_kuhxm_17",
  "card--raised": "_card--raised_kuhxm_21",
  card__label: y,
  card__input: F,
  "card__input--active": "_card__input--active_kuhxm_36",
  "card__input--inactive": "_card__input--inactive_kuhxm_37",
  "card--sr-only": "_card--sr-only_kuhxm_54"
}, N = l(
  ({ className: c = "", layout: e, border: _, borderWidth: d, children: o, raised: i, ...p }, h) => /* @__PURE__ */ a(
    m,
    {
      ref: h,
      bg: "primary",
      "data-role": "card",
      direction: "column",
      className: u(
        {
          [r.card]: !0,
          [r["card--border"]]: _ === !0,
          [r["card--border-1"]]: String(d) === "1",
          [r["card--border-2"]]: String(d) === "2",
          [r["card--raised"]]: !!i,
          [r["card--full-width"]]: e === "full-width"
        },
        c
      ),
      role: "region",
      ...p,
      children: o
    }
  )
), q = l(
  ({ children: c, className: e = "", isSquare: _, hidden: d = !0, ...o }, i) => /* @__PURE__ */ n("label", { className: r.card__label, children: [
    c ? /* @__PURE__ */ a("span", { className: r["card--sr-only"], children: c }) : null,
    /* @__PURE__ */ a(
      "input",
      {
        className: u(
          r.card__input,
          {
            [r["card--sr-only"]]: !!d
          },
          e
        ),
        ...o,
        ref: i
      }
    ),
    d ? /* @__PURE__ */ n(x, { children: [
      /* @__PURE__ */ a("span", { className: r["card__input--active"], children: /* @__PURE__ */ a(
        s,
        {
          icon: _ ? f : C,
          color: "success",
          size: "lg"
        }
      ) }),
      /* @__PURE__ */ a("span", { className: r["card__input--inactive"], children: /* @__PURE__ */ a(
        s,
        {
          icon: _ ? b : k,
          size: "lg",
          color: "inherit"
        }
      ) })
    ] }) : null
  ] })
), t = (c) => /* @__PURE__ */ a(m, { direction: "column", ...c }), H = t, R = t, A = t;
N.displayName = "Card";
export {
  N as Card,
  R as CardBody,
  A as CardFooter,
  H as CardHeader,
  q as CardInput
};
